<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ user.full_name }}
        </p>
        <span class="user-status">{{ $role}}</span>
      </div>
      <b-avatar
        size="40"
        :src="user.profile_image_path"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon v-if="!user.full_name" icon="UserIcon" size="22" />
      </b-avatar>
    </template>

    <b-dropdown-item
      :to="{ name: 'profile' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="UserIcon" class="mr-50" />
      <span>{{ $t("site.profile") }}</span>
    </b-dropdown-item>

    <b-dropdown-divider />

    <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
      <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
      <span>{{ $t("site.logout") }}</span>
    </b-dropdown-item>

    <b-dropdown-item link-class="d-flex align-items-center" v-if="impersonate" >
      <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
      <a @click="finishimpersonation"><span>{{$t('site.finish')}} {{ $t("site.impersonate") }}</span></a>
    </b-dropdown-item>
    
    </b-nav-item-dropdown
  >
</template>

<script>
import { avatarText } from "@core/utils/filter";
import Auth from "@/Apis/Auth";
import Cookies from 'js-cookie';
import Swal from "sweetalert2";
export default {
  computed: {
    // user() {
    //   console.log(Auth.USER);
    //   return Auth.USER;
    // },
  },
  data() {
    return {
      user : {},
      eduPrograms:[],
      impersonate:false,
      avatarText,
    };
  },
  created() {
    this.user = Auth.USER;
    this.impersonate= Cookies.get('impersonate');
  },
  methods: {
    logout() {
      Auth.logOut();
    },
    async finishimpersonation(){
     let response= await Auth.finishImpersonate();

      if (response) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: this.$i18n.t("site.successfully"),
              showConfirmButton: false,
              timer: 1000,
            }).then(()=>{ 
              window.location.href='/dashboard'
            });
            //
          } else {
            Swal.fire({
              position: "center",
              icon: "error",
              title: "Oops...",
              text: res.message,
              showConfirmButton: false,
              timer: 1000,
            });
          }
      
    }
  },
  watch: {
    "Auth.USER"(newValue) {
      console.log(newValue);
     },
  },
};
</script>
